import { MatchShell } from './MatchShell';

export function MatchEntryDetailPage() {
  return (
    <MatchShell>
      <div>
        <h1 className="mb-2 text-xl font-semibold text-ink">Match — Entry detail</h1>
        <p className="text-sm text-ink-muted">
          Full detail page coming soon.
        </p>
      </div>
    </MatchShell>
  );
}
